import {request} from '@/utils/request.js'

// 领取红包
export function getLiBao(data) {
    return request({
      method: 'POST',
      url: '//api.lepu.cn/app/gift/receive',
      params:data
    })
}